export { AverageMetricsContainer as AverageMetrics } from './AverageMetrics.container';
